var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.session.user_data != null)?_c('v-card-text',[_vm._v(" "+_vm._s(_vm.$t("erp.widgets.greeting",{name: _vm.session.user_data.first_name}))+" "+_vm._s(_vm.$t("erp.widgets.greeting_text"))+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }